import { combineReducers } from "redux";
import CitiesReducers from './CitiesReducer';
import filterReducer from './filterReducer';

export default combineReducers({
  cities_reducer: CitiesReducers,
  current_filter: filterReducer
});
